import { isAfter, startOfDay } from 'date-fns';

export default function isRenewalUpdateRequired(
  renewalDeadlineDate?: string | null,
): boolean {
  if (!renewalDeadlineDate) return false;
  const deadline = startOfDay(new Date(renewalDeadlineDate));
  const today = startOfDay(new Date());
  return !isAfter(deadline, today);
}
